import _default from './Advertisement';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/views/Advertisement/index.js
// module id = 704
// module chunks = 0